{
  "title": "Shillelagh",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 bonus action",
  "range": "Touch",
  "components": "V, S, M (mistletoe, a shamrock leaf, and a club or quarterstaff)",
  "duration": "1 minute",
  "description": [
    "The wood of a club or quarterstaff you are holding is imbued with nature’s power. For the duration, you can use your spellcasting ability instead of Strength for the attack and damage rolls of melee attacks using that weapon, and the weapon’s damage die becomes a d8. The weapon also becomes magical, if it isn’t already. The spell ends if you cast it again or if you let go of the weapon."
  ],
  "spellLists": ["druid"]
}
